import React, {ReactElement, ReactNode, useContext} from 'react';
import {cx} from '@emotion/css';

import DeviceContext, {Device} from '../../../../RootProvider/DeviceContext';
import Hero from '../Hero/Hero';
import JumpToAnchorMenu from '../../JumpToAnchorMenu/JumpToAnchorMenu';
import {LinkProp} from '../../../../types';
import GeneralLayout from '../GeneralLayout/GeneralLayout';
import TrustpilotWidget from '../../TrustpilotWidget/TrustpilotWidget';
import {TrustpilotTheme, TrustpilotWidgetVariant} from '../../TrustpilotWidget/trustpilotWidgetVariantConfig';

import styles from './KnowledgeLayout.styles';

interface Props {
  customCtaText?: string;
  image: string;
  children: ReactNode;
  links: LinkProp[];
  heroTitle: string;
  heroDescription: string;
}

function KnowledgeLayout({children, customCtaText, image, links, heroTitle, heroDescription}: Props): ReactElement {
  const deviceContext = useContext(DeviceContext);
  const isDesktop = deviceContext === Device.DESKTOP;
  const isTablet = deviceContext === Device.TABLET;

  return (
    <GeneralLayout>
      <Hero customCtaText={customCtaText} image={image} title={heroTitle} description={heroDescription}>
        <TrustpilotWidget
          variant={isTablet || isDesktop ? TrustpilotWidgetVariant.MINI : TrustpilotWidgetVariant.MICROSTAR}
          theme={TrustpilotTheme.DARK}
        />
      </Hero>
      {isDesktop ? (
        <div className={cx(styles.container, 'container')} data-testid="layout.knowledge.desktopContents">
          <div className="row">
            <div className="col-md-3">
              <JumpToAnchorMenu
                links={links}
                shouldShowQuoteFormCTA
                shouldShowTrustpilot
                customCtaText={customCtaText}
              />
            </div>
            <div className="col-md-9">
              <div className={cx(styles.content)}>{children}</div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <JumpToAnchorMenu links={links} shouldShowQuoteFormCTA shouldShowTrustpilot customCtaText={customCtaText} />
          <div className={cx(styles.content)}>{children}</div>
        </div>
      )}
    </GeneralLayout>
  );
}

export default KnowledgeLayout;
